<ng-container [ngSwitch]="mode">
    <ng-container *ngSwitchCase="'pauschal'" [ngTemplateOutlet]="pauschal"></ng-container>
    <ng-container *ngSwitchCase="'railtravel'" [ngTemplateOutlet]="railtravel"></ng-container>
    <ng-container *ngSwitchCase="'hotelonly'" [ngTemplateOutlet]="hotelonly"></ng-container>
    <ng-container *ngSwitchCase="'sktvhotelonly'" [ngTemplateOutlet]="sktvhotelonly"></ng-container>
    <ng-container *ngSwitchCase="'sktvpauschal'" [ngTemplateOutlet]="sktvpauschal"></ng-container>
    <ng-container *ngSwitchCase="'flight'" [ngTemplateOutlet]="flight"></ng-container>
    <ng-container *ngSwitchCase="'oneway'" [ngTemplateOutlet]="flight"></ng-container>
    <ng-container *ngSwitchCase="'carrent'" [ngTemplateOutlet]="carrent"></ng-container>
    <ng-container *ngSwitchDefault [ngTemplateOutlet]="other"></ng-container>
</ng-container>

<ng-template #flight>
    <app-offerpackflightcard *ngIf="gpsData?.length > 0" [gpsData]="gpsData" (removeFromList)="removeFromListF()"
        [mode]="mode" [title]="modeText" (changeindex)="changeindexF($event)" (openSetComment)="openSetComment($event)"
        [currentCustomer]="currentCustomer" [offer]="offer" [booking]="booking" [reference]="reference()"
        [index]="index()" [offerid]="offerid()" [desktopTemplate]="desktopTemplate">
    </app-offerpackflightcard>
</ng-template>

<ng-template #pauschal>
    <ng-container *ngIf="showOffer && hotel">
        <app-offerpackpauschalcard style="width: 100%;display: block;" [hotel]="hotel"
            (changeindex)="changeindexF($event)" [reference]="reference()" [mode]="mode" [title]="'Pauschal'"
            [currentCustomer]="currentCustomer" (removeFromList)="removeFromListF()" [offer]="offer"
            (openSetComment)="openSetComment($event)" [categoryAr]="categoryAr" (saveImagePos)="saveImagesList($event)"
            [booking]="booking" [index]="index()" [offerid]="offerid()">
        </app-offerpackpauschalcard>
    </ng-container>
</ng-template>

<ng-template #railtravel>
    <ng-container *ngIf="showOffer && hotel">
        <app-offerpackpauschalcard style="width: 100%;display: block;" [hotel]="hotel" [mode]="mode"
            [title]="'Bahn + Hotel'" (removeFromList)="removeFromListF()" (changeindex)="changeindexF($event)"
            [currentCustomer]="currentCustomer" [offer]="offer" [categoryAr]="categoryAr" [booking]="booking"
            [index]="index()" [reference]="reference()" [offerid]="offerid()" (openSetComment)="openSetComment($event)"
            (saveImagePos)="saveImagesList($event)">
        </app-offerpackpauschalcard>
    </ng-container>
</ng-template>

<ng-template #hotelonly>
    <ng-container *ngIf="showOffer && hotel">
        <app-offerpackpauschalcard style="width: 100%;display: block;" [hotel]="hotel" [mode]="mode"
            [title]="'Nur Hotel'" [currentCustomer]="currentCustomer" (changeindex)="changeindexF($event)"
            (removeFromList)="removeFromListF()" [offer]="offer" [categoryAr]="categoryAr"
            (saveImagePos)="saveImagesList($event)" [booking]="booking" [reference]="reference()" [index]="index()"
            (openSetComment)="openSetComment($event)" [offerid]="offerid()">
        </app-offerpackpauschalcard>
    </ng-container>
</ng-template>

<ng-template #sktvhotelonly>
    <ng-container *ngIf="showOffer && sktvContent">
        <app-offerpackssktvcard style="width: 100%;display: block;" [mode]="'hotelonly'" [title]="'Nur Hotel'"
            [sktvContent]="sktvContent" (removeFromList)="removeFromListF()" (changeindex)="changeindexF($event)"
            [currentCustomer]="currentCustomer" (saveImagePos)="saveImagesList($event)" [offer]="offer"
            [categoryAr]="categoryAr" [booking]="booking" (openSetComment)="openSetComment($event)" [index]="index()"
            [reference]="reference()" [offerid]="offerid()">
        </app-offerpackssktvcard>
    </ng-container>
</ng-template>

<ng-template #sktvpauschal>
    <ng-container *ngIf="showOffer && sktvContent">
        <app-offerpackssktvcard style="width: 100%;display: block;" [mode]="'pauschal'" [title]="'Pauschal'"
            [sktvContent]="sktvContent" (removeFromList)="removeFromListF()" (changeindex)="changeindexF($event)"
            [currentCustomer]="currentCustomer" [offer]="offer" [categoryAr]="categoryAr"
            (saveImagePos)="saveImagesList($event)" [booking]="booking" [reference]="reference()" [index]="index()"
            (openSetComment)="openSetComment($event)" [offerid]="offerid()">
        </app-offerpackssktvcard>
    </ng-container>
</ng-template>

<ng-template #carrent>
    <app-offerpackcarrentcard style="width: 100%;display: block;" [currentCustomer]="currentCustomer" [offer]="offer"
        [booking]="booking" [title]="modeText" [index]="index()" [reference]="reference()" [offerid]="offerid()"
        (removeFromList)="removeFromListF()" (changeindex)="changeindexF($event)"
        (openSetComment)="openSetComment($event)" [desktopTemplate]="desktopTemplate">
    </app-offerpackcarrentcard>
</ng-template>

<ng-template #other>
    <button class="offerheadertext" (click)="removeFromListF()">
        <span multilang>Andere</span>
        <mat-icon class="rmico">cancel</mat-icon>
    </button>
</ng-template>